module.exports = __webpack_public_path__ + "static/img/icon6.9ed79f59.png";